export const topCities = [
  {
    id: 1,
    path: "karachi",
    name: "Karachi",
  },
  {
    id: 2,
    path: "quetta",
    name: "Quetta",
  },
  {
    id: 3,
    path: "islamabad",
    name: "Islamabad",
  },
  {
    id: 4,
    path: "hyderabad",
    name: "Hyderabad",
  },
  {
    id: 5,
    path: "multan",
    name: "Multan",
  },
  {
    id: 6,
    path: "peshawar",
    name: "Peshawar",
  },
  {
    id: 7,
    path: "gujranwala",
    name: "Gujranwala",
  },
  {
    id: 8,
    path: "rawalpindi",
    name: "Rawalpindi",
  },
  {
    id: 9,
    path: "faisalabad",
    name: "	Faisalabad",
  },
  {
    id: 10,
    path: "lahore",
    name: "Lahore",
  },
];

export const popularCities = [
  {
    id: 1,
    path: "jatoi",
    name: "Jatoi",
  },
  {
    id: 2,
    path: "haroonabad",
    name: "Haroonabad",
  },
  {
    id: 3,
    path: "daharki",
    name: "Daharki",
  },
  {
    id: 4,
    path: "narowal",
    name: "Narowal",
  },
  {
    id: 5,
    path: "tando",
    name: "Tando Muhammad Khan",
  },
  {
    id: 6,
    path: "kamber",
    name: "Kamber Ali Khan",
  },
  {
    id: 7,
    path: "mirpur",
    name: "Mirpur Mathelo",
  },
  {
    id: 8,
    path: "kandhkot",
    name: "Kandhkot",
  },
  {
    id: 9,
    path: "bhalwal",
    name: "Bhalwal",
  },
  {
    id: 10,
    path: "gwadar",
    name: "Gwadar",
  },
];

export const othercities = [
  {
    id: 1,
    path: "mianwali",
    name: "Mianwali",
  },
  {
    id: 2,
    path: "kabal",
    name: "Kabal",
  },
  {
    id: 3,
    path: "lodhran",
    name: "Lodhran",
  },
  {
    id: 4,
    path: "hasilpur",
    name: "Hasilpur",
  },
  {
    id: 5,
    path: "charsadda",
    name: "Charsadda",
  },
  {
    id: 6,
    path: "bhakkar",
    name: "Bhakkar",
  },
  {
    id: 7,
    path: "badin",
    name: "Badin",
  },
  {
    id: 8,
    path: "arif",
    name: "Arif Wala",
  },
  {
    id: 9,
    path: "ghotki",
    name: "Ghotki",
  },
  {
    id: 10,
    path: "sambrial",
    name: "Sambrial",
  },
];

export const internationaCities = [
  {
    id: 1,
    path: "delhi",
    name: "Delhi",
  },
  {
    id: 2,
    path: "istanbul",
    name: "Istanbul",
  },
  {
    id: 3,
    path: "kuala",
    name: "Kuala Lumpur",
  },
  {
    id: 4,
    path: "dubai",
    name: "Dubai",
  },
  {
    id: 5,
    path: "paris",
    name: "Paris",
  },
  {
    id: 6,
    path: "singapore",
    name: "Singapore",
  },
  {
    id: 7,
    path: "macau",
    name: "Macau",
  },
  {
    id: 8,
    path: "london",
    name: "London",
  },
  {
    id: 9,
    path: "bangkok",
    name: "Bangkok",
  },
  {
    id: 10,
    path: "hong",
    name: "Hong Kong",
  },
];
